module.exports = __webpack_public_path__ + "static/media/tutorial-excercise-background.8bcfecb0.svg";